import { Button, FlexBox, Icon, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { ReaderSummaryFeedbackType } from '../../types'
import { useState } from 'react'
import { useReaderSummary } from '../../lib/ctx/reader_summary'

interface Props {
  className?: string
  onSubmit: () => void
}

export const ReaderSummaryFeedbackForm = ({
  className = '',
  onSubmit,
}: Props) => {
  const { colors } = useTheme()
  const [selectedOption, setSelectOption] =
    useState<ReaderSummaryFeedbackType | null>(null)
  const sendFeedback = useReaderSummary((s) => s.sendFeedback)
  const unselected = !selectedOption

  const handleOnSubmit = async () => {
    if (unselected) return
    onSubmit()
    await sendFeedback({ positive: false, feedback: selectedOption })
  }

  const options: { id: ReaderSummaryFeedbackType; text: string }[] = [
    {
      id: 'not_relevant',
      text: "Doesn't match the books I read",
    },
    {
      id: 'stale',
      text: "I've received this summary before",
    },
    {
      id: 'harmful',
      text: 'Contains problematic content',
    },
    {
      id: 'none',
      text: 'Something else',
    },
  ]

  return (
    <div
      className={cx(
        css`
          width: 100%;
        `,
        className
      )}
    >
      <ul
        className={css`
          margin-top: 5px;
        `}
      >
        {options.map((o) => {
          const selected = selectedOption === o.id

          return (
            <li
              key={o.id}
              className={css`
                padding: 8px 0;
                padding-right: 10px;
                cursor: pointer;
              `}
              onClick={() => setSelectOption(o.id)}
            >
              <FlexBox
                className={css`
                  height: 32px;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                `}
              >
                <FlexBox
                  className={css`
                    width: 100%;
                  `}
                  as="span"
                  alignItems="center"
                  gap="8px"
                >
                  <Text type="body" sizing="M" color={colors.uiWhite}>
                    {o.text}
                  </Text>
                </FlexBox>
                <Icon
                  className={css`
                    flex-shrink: 0;
                    opacity: ${selected ? 1 : 0};
                  `}
                  type="tick"
                  fill={colors.uiPewterGrey}
                />
              </FlexBox>
            </li>
          )
        })}
      </ul>
      <Button
        className={css`
          margin-top: 10px;
          width: 100%;
          opacity: ${unselected ? 0.5 : 1};
        `}
        onClick={handleOnSubmit}
        negative
      >
        Submit
      </Button>
    </div>
  )
}
